import { useTranslation } from "react-i18next";
import { toast } from "sonner";
import { Button } from "@components/Button";
import { DownloadIcon } from "@components/icons";
import { useGetPaperBillFileMutation } from "@services/payments/mutations";
import { type IPaperBill } from "@services/payments/types";
import { downloadFile, isNullOrUndefined } from "@utils/common";

interface IPaperBillDownloadButtonProps {
  paperBill: IPaperBill;
  periodId: number;
}

export const PaperBillDownloadButton: React.FC<
  IPaperBillDownloadButtonProps
> = ({ paperBill, periodId }) => {
  const { t } = useTranslation();
  const { address } = paperBill;

  const { mutateAsync: getPaperBillFile, isPending } =
    useGetPaperBillFileMutation();

  const download = () => {
    toast.promise(
      getPaperBillFile({
        jointBillServiceId: paperBill.jointBillServiceId,
        periodId,
      }),
      {
        loading: t("paperBillPaymentModal.interactions.loading"),
        success: (file) => {
          if (!isNullOrUndefined(file?.data)) {
            downloadFile(file);
          }
          return t("paperBillPaymentModal.interactions.success");
        },
        error: t("paperBillPaymentModal.interactions.error"),
      },
    );
  };

  return (
    <Button
      className="w-full"
      icon={DownloadIcon}
      onClick={download}
      isLoading={isPending}
    >
      {address}
    </Button>
  );
};
